import { CountUp } from 'countup.js';
import 'waypoints/lib/noframework.waypoints.min.js';

const NumberCounter = () => {

    function countStart(){
        
        const time = document.querySelector('.stats-columns');
        const counters = document.querySelectorAll('.js-count-up'),
        options = {
            useEasing: true,
            useGrouping: true,
            separator: ",",
            decimal: ".",
            duration: parseInt(time.getAttribute('time'), 10)
        };

        counters.forEach( (item) => {
            const value = item.dataset.value;
            const counter = new CountUp(item, value, options);
            counter.start();
        });
    }

    new Waypoint({
    element: document.querySelector('.stats-columns'),
    handler: function() {
        countStart()
        //this.destroy() //for once
    },
    offset: '50%'
    });

}

export default NumberCounter
